module.exports = __webpack_public_path__ + "static/media/rain.db075df0.png";